<template>
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--mypage is-hide">
      <header class="l-header l-header--top">
        <public-page-header />
      </header>
      <section class="l-content-area">
        <div class="l-content">
          <section class="p-bloc p-bloc--mypage">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">
                <section class="p-mypage">
                  <div class="p-mypage__content">
                    <div class="mypage-content">
                      <div class="p-mypage__page mypage-bloc">
                        <div class="mypage-bloc__content">
                          <div class="page__bloc page__bloc--terms c-kiyaku">
                            <div class="blog-page">
                              <article id="post-inner">
                                <header class="article-header">
                                  <h1>プライバシーポリシー（個人情報保護方針）</h1>
                                </header>

                                <!-- post -->
                                <section class="article-content">
                                  <p>
                                    hubsynch株式会社（以下「当社」といいます）は、インターネットを活用した決済マネージメントサービスを核とした事業活動を行っています。当社は、お客様に質の高い事業・サービスを提供する会社として、お客様にご満足いただき、便利で有益な質の高い商品・サービスを提供することを目指しています。このため、当社ではお客様からお預かりする個人情報をはじめ、当社に関わっていただく様々な方々の個人情報を活用しており、個人情報の保護を図ることは当社にとって最も重要な責務の一つと考えております。
                                  </p>
                                  <p>
                                    当社は、事業内容と規模を考慮し、事業遂行のために必要な範囲内で利用目的を明確に定め、適切に個人情報の取得、利用および提供を行います。取得した個人情報は、利用目的の範囲内でのみ利用し、目的外利用を行わないための措置を講じます。また、個人情報への不正アクセス、個人情報の紛失、破壊、滅失、き損、改ざんおよび漏洩等のリスクを認識し、予防並びに是正のために必要な対応策を講じます。
                                  </p>
                                  <p>
                                    当社ではここに「プライバシーポリシー（個人情報保護方針）」を定め、個人情報の必要かつ適切な保護を行い、維持をすることに努めます。当社の役員、社員、派遣社員、臨時雇用者を含む全ての従業者は、個人情報の取扱いおよび管理に際し、必ず本プライバシーポリシー、個人情報に関する法令、国が定める指針、およびその他規範を遵守します。
                                  </p>
                                  <p>
                                    この方針を具現化するために当社では、JISQ15001に準拠したコンプライアンス・プログラムを構築し､常に社会的要請の変化に着目し､個人情報保護マネジメントシステムの継続的改善を含め全社を挙げて取り組むことを宣言します。
                                  </p>
                                  <p>当社のプライバシーポリシー（個人情報保護方針）、個人情報の取扱いについての苦情、ご相談については、下記お問合せ窓口にて承ります。</p>
                                  <p style="text-align: right;">制定日：2017年7月3日<br>
                                    hubsynch株式会社<br>
                                    代表取締役　沖津貴俊</p>
                                  <p><strong>＜お問合せ窓口＞</strong><strong><br>
                                    </strong>hubsynch株式会社<br>
                                    <u><a href="/contactus">お問合せフォーム</a><br>
                                    </u>個人情報利用目的や開示請求手続等は、当社の<a href="/kojinjoho"><u>「個人情報の取扱いについて」</u></a>をご参照ください。
                                  </p>
                                  <p>&nbsp;</p>
                                  <h1>hubsynchにおける個人情報の取扱いについて</h1>
                                  <p>当社が取扱うお客さま等の個人情報について、以下のとおり公表いたします。なお、当社のプライバシーポリシー（個人情報保護方針）につきましては、
                                    <router-link id="link-privacy-policy-1"
                                      :to="{ name: 'privacy.policy' }">こちら</router-link>をご覧ください。
                                  </p>
                                  <h4>1. 当社の名称・住所・代表者の氏名</h4>
                                  <p align="left">名称：hubsynch株式会社<br>
                                    住所：〒108-0071 東京都港区白金台三丁目2番10号白金台ビル4B<br>
                                    代表者：代表取締役　沖津貴俊</p>
                                  <div>
                                    <h4 align="left">2. 個人情報保護管理者</h4>
                                    <p>hubsynch株式会社　代表取締役　沖津貴俊<br>
                                      連絡先：下記5の「hubsynchサポートセンター」参照</p>
                                    <div>
                                      <h4 align="left">3. 個人情報の利用目的</h4>
                                    </div>
                                    <div>
                                      当社が取得または保有するお客さま等の個人情報は、以下の目的で利用いたします。その他の利用目的で個人情報を利用する場合には、個人情報を取得するときに、その利用目的と問合せ先を明示します。
                                      なお、これらの利用目的の範囲を超えてお客さま等の個人情報を利用する場合は、改めて利用目的をお知らせし、同意を得ることとします。ただし、取得状況からみて利用目的が明らかであると認められる場合は、除きます。<br>
                                      ■当社の保有個人データの利用目的</div>
                                    <div>
                                      <br>
                                      <table class="privacy-table">
                                        <tbody>
                                          <tr>
                                            <td>
                                              <p class="p1">顧客情報</p>
                                            </td>
                                            <td>
                                              <p class="p1"><span
                                                  class="s1">当社サービスを提供する目的および事務連絡</span>・アフターフォロー等、それに付帯する業務を実行するため<span
                                                  class="s2">DM</span>発送等、当社のサービスをご紹介するため</p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">問合せ情報</p>
                                            </td>
                                            <td>
                                              <p class="p1">製品やサービス等に関する意見、要望、問合せについての受付と回答するため</p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">取引先情報</p>
                                            </td>
                                            <td>
                                              <p class="p1">当社との取引に関する事務、その他それに付帯する業務を実行するため</p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">従業者情報</p>
                                            </td>
                                            <td>
                                              <p class="p1"><span
                                                  class="s1">従業者管理に係わる業務に利用するため（業務</span>・労務・人事管理業務、給与関連業務、福利厚生業務等）
                                              </p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">採用情報</p>
                                            </td>
                                            <td>
                                              <p class="p1">採用に係わる業務に利用するため（採用に関する情報提供、採用可否判断、採用業務に関する連絡等）</p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">ユーザー情報</p>
                                            </td>
                                            <td>
                                              <p class="p1"><span class="s1">a.&nbsp;</span>ユーザーのお問合せ対応のため</p>
                                              <p class="p1"><span class="s1">b.&nbsp;</span>ユーザーの登録情報管理のため</p>
                                              <p class="p1"><span class="s1">c.&nbsp;</span>ユーザーが購入した商品等の発送業務のため</p>
                                              <p class="p1"><span class="s1">d.&nbsp;</span>商品、デジタルコンテンツおよびサービス提供のため</p>
                                              <p class="p1"><span class="s1">e.&nbsp;</span>商品、デジタルコンテンツおよびサービス代金ご請求のため
                                              </p>
                                              <p class="p1"><span class="s1">f.&nbsp;</span>メールマガジン配信のため</p>
                                              <p class="p1"><span class="s1">g.&nbsp;</span>当社顧客および第三者の商品等のご案内のため</p>
                                              <p class="p1"><span
                                                  class="s1">h.&nbsp;</span>マーケティング、商品企画等のための統計データ作成のため（個人は識別できません。）
                                              </p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <p class="p1">本人および代理人の情報（開示等請求時）</p>
                                            </td>
                                            <td>
                                              <p class="p1">開示等の求めに回答するため</p>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <br>
                                    </div>
                                    <div>
                                      <div>
                                        <h4 align="left">4. クレジットカード情報を含む個人情報の取扱いについて</h4>
                                      </div>
                                      <p align="left">
                                        当社がユーザーからクレジット情報(カード名義・カード番号・有効期間）を取得する目的、クレジット情報の取得者名、提供先名、保存期間は、以下のとおりです。<br>
                                        （1）利用目的ご購入した商品およびサービスの代金を決済するため<br>
                                        （2）情報の取得者名hubsynch株式会社<br>
                                        （3）情報の提供先名<br>
                                        ユーザーがクレジットカード決済時にご利用いただいた各カード会社を含む各種決済事業者および以下いずれかの決済代行会社<br>
                                        ・株式会社ペイジェント<br>
                                        ・三菱UFJニコス株式会社<br>
                                        ・SBペイメントサービス株式会社<br>
                                        ・SMBCファイナンスサービス株式会社<br>
                                        （4）保存期間<br>
                                        クレジットカードの決済および登録は、上記「3.情報の提供先名」記載の各種決済事業者および決済代行会社を利用しております。各種決済事業者および決済代行会社への開示後は、当社では一切クレジットカード情報を保持いたしません。ただし、ユーザーがhubsynchを継続利用するため、クレジットカード情報の登録をされた場合は、当社においても、クレジットカード情報を登録します。hubsynchでクレジットカード情報を登録されている場合には、以下いずれかのタイミングで登録情報の廃棄を行います。<br>
                                        ・ユーザーがクレジットカード登録を解除したとき<br>
                                        ・ユーザーがhubsynchを退会したとき</p>
                                      <div>
                                        <h4 align="left">5.&nbsp;個人データの取扱いに関する苦情・相談について</h4>
                                      </div>
                                      <p align="left">当社の個人情報の取扱いに関するお問合せ、苦情については、下記窓口にご連絡ください。<br>
                                        【hubsynchサポートセンター】<br>
                                        窓口責任者：個人情報保護管理者<br>
                                        住所：〒108-0071 東京都港区白金台三丁目2番10号白金台ビル4B<br>
                                        お問合せフォーム　<a
                                          href="https://hubsynch.com/contactus/">https://hubsynch.com/contactus/</a></p>
                                      <div>
                                        <h4 align="left">6. 開示等のご請求手続</h4>
                                      </div>
                                      <p align="left">
                                        当社の保有個人データについて、ご本人、法定代理人または委任による代理人から、開示等（利用目的の通知、開示、内容の訂正、追加または削除、利用の停止、消去および第三者への提供の停止、第三者提供記録の開示）のご請求が可能です。<br>
                                        （1） 手続<br>
                                        開示等のご請求は、上記5の【hubsynchサポートセンター】にご連絡ください。請求内容確認後、当社所定の様式をお送りしますので、必要事項をご記入のうえ、返送ください。その際、請求者または代理人がご本人であること、また代理人が代理権を有することを当社所定の方法により確認させていただきます。なお、保有個人データの削除、利用の停止、消去および第三者への提供の停止をご希望の場合は、当社サービスのご提供ができなくなることをご了承ください。<br>
                                        （2）手数料等<br>
                                        当社への手数料はいただきませんが、ご請求にかかる切手代、公文書の発行費用、電話代等のすべての費用は、ご請求者様にご負担いただきます。</p>
                                      <div>
                                        <h4 align="left">7. 安全管理措置</h4>
                                      </div>
                                      <div>
                                        <p>当社が講じる個人情報の安全管理措置は、以下のとおりです。<br>
                                          （1）基本方針の策定<br>
                                          個人情報の適正な取扱いの確保のため「関係法令・ガイドライン等の遵守」、「個人情報の安全管理措置に関する事項」、「質問および苦情相談の窓口」等について、「個人情報保護方針」を策定しています。<br>
                                          （2）組織的安全管理措置<br>
                                          個人情報の管理に関する責任者の設置とその役割の明確化、個人情報の取扱状況の点検および監査の体制整備と実施、漏えい事案等に対する体制の整備等を実施しています。<br>
                                          （3）人的安全管理措置<br>
                                          従業者との「非開示契約」の締結、個人情報の取扱いに関する留意事項についての従業者への周知徹底および研修等を実施しています。<br>
                                          （4）物理的安全管理措置<br>
                                          紛失・盗難を防ぐための書類・外部媒体等の施錠保管、裁断・焼却・溶解等復元が著しく困難な手段での個人情報廃棄、責任者の承諾なく個人情報を持ち出すことの禁止、個人情報を持ち運ぶ際の暗号化や封緘等の措置を実施しています。<br>
                                          （5）技術的安全管理措置<br>
                                          個人情報を取扱う機器への外部からの不正アクセスまたは不正ソフトウェアから保護する仕組みの導入、担当者および取扱う個人データの範囲の限定などのアクセス制御の実施、不正アクセスを防止するための強固なパスワードの使用、IDの共有禁止、暗号化設定可能な機器の使用等の措置を実施しています。<br>
                                          （6）外的環境の把握<br>
                                          個人情報の一部を含めた情報の保管についてクラウドサービスを利用しており、これらの個人情報は、当該事業者の管理のもと、海外に保管されております。当社は、各国の個人情報の保護に関する制度を把握したうえで、必要かつ適切な安全管理措置を実施しています。<br>
                                          ■参考：個人情報保護委員会　外国における個人情報の保護に関する制度等の調査<br>
                                          <a
                                            href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku">https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku</a>
                                        </p>
                                        <div>
                                          <h4 align="left">8. WEBサイトにおける個人情報の取扱いについて</h4>
                                        </div>
                                        <ol>
                                          <li>クッキー（Cookie）の利用について<br>
                                            当社のWEBサイトでは、お客さま等のコンピュータを特定し利便性を高めるために、クッキー（Cookie）と呼ばれる情報を、お客さま等のコンピュータに送ります。クッキー情報はお客さま等のコンピュータを特定するために使用し、お客さま等個人を特定するために使用することはありません。
                                          </li>
                                          <li>ＳＳＬについて<br>
                                            当社のWEBサイトは、お客さま等の個人情報を保護するために「SSL」に対応しています。
                                            お客さま等が入力される名前や住所あるいは電話番号などの個人情報が自動的に暗号化されて送受信されるため、万が一、送信データが第三者に傍受された場合でも、内容が盗み取られる心配はありません。
                                          </li>
                                          <li>アクセスログについて<br>
                                            当社のWEBサイトでは、アクセスされた方の情報をアクセスログという形で記録しています。アクセスログは、アクセスされた方のドメイン名やIPアドレス、使用しているブラウザの種類、アクセス日時等が含まれますが、通常は個人を特定できる情報を含むものではありません。これらのアクセスログは、WEBサイトの保守管理や利用状況に関する統計分析のために活用されますが、それ以外の目的で利用されることはありません。
                                          </li>
                                          <li>Googleアナリティクスの利用について<br>
                                            当社のWEBサイトにおいて、その利用状況を把握するために、Googleアナリティクスを利用することがあります。Googleアナリティクスは、ファーストパーティクッキーを利用して、当社WEBサイトへのアクセス情報を個人を特定することなく収集します。アクセス情報の収集方法および利用方法については、Googleアナリティクスサービス利用規約およびGoogleプライバシーポリシーによって定められています。Googleアナリティクスについての詳細は、以下のページをご参照ください。<br>
                                            <a href="http://www.google.com/analytics"
                                              target="_blank">http://www.google.com/analytics</a>
                                          </li>
                                        </ol>
                                        <div>
                                          <div>
                                            <h4 align="left">9.&nbsp;外国にある第三者への提供</h4>
                                          </div>
                                          <p><span
                                              style="color: #333333; line-height: 24px;">当社は、電子メール配信サービスであるSendGridを利用しており、メールアドレス等の個人情報は、SendGridの運営主体である米国法人のTwilio
                                              Inc.で保持、管理されています。Twilio
                                              Inc.のプライバシーポリシーでは、各国のデータ保護法および日本の個人情報保護法を遵守してこれらの移転を行っていることをTwilio
                                              IncのHPで確認しています。<br>
                                              1. 提供先：Twillio Inc.（国名：アメリカ）<br>
                                              2. 当該外国における個人情報保護に関する制度：<a
                                                href="https://www.ppc.go.jp/files/pdf/USA_report.pdf">https://www.ppc.go.jp/files/pdf/USA_report.pdf<br>
                                              </a>3.&nbsp;提供先である第三者が講ずる個人情報保護のための措置に関する情報：提供先の個人データの取扱いについては、国内の個人情報取扱事業者が求められる措置とAPECと同水準の措置を講じていることを確認しています。</span>
                                          </p>
                                        </div>
                                        <p align="right">最終改定日：2026年09月01日<br>
                                          制定日：2014年06月01日</p>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              </article>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>
      </section>
      <Footer v-if="isLoggedIn"/>
      <PublicFooter v-else/>
    </div>
  </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});

function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
</script>

<style scoped>
.article-content h1 {
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .article-content h1 {
    font-size: 1.2rem;
    margin: 1.5rem 0 1rem 0;
  }
}
</style>